"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var useForkRef_1 = __importDefault(require("./utils/useForkRef"));
var renderPropType_1 = __importDefault(require("./utils/renderPropType"));
var wrapEvent_1 = __importDefault(require("./utils/wrapEvent"));
var useAcdcInputProps_1 = __importDefault(require("./useAcdcInputProps"));
var AcdcInput = function (_a) {
    var _b = _a.tag, tag = _b === void 0 ? 'input' : _b, onChangeProp = _a.onChange, onFocusProp = _a.onFocus, onBlurProp = _a.onBlur, onKeyDownProp = _a.onKeyDown, inputRef = _a.inputRef, children = _a.children, props = __rest(_a, ["tag", "onChange", "onFocus", "onBlur", "onKeyDown", "inputRef", "children"]);
    var inputProps = useAcdcInputProps_1.default();
    var _c = __read(inputProps, 1), _d = _c[0], onKeyDown = _d.onKeyDown, onChange = _d.onChange, onFocus = _d.onFocus, onBlur = _d.onBlur, value = _d.value, focusInputRef = _d.ref, restInputProps = __rest(_d, ["onKeyDown", "onChange", "onFocus", "onBlur", "value", "ref"]);
    var ref = useForkRef_1.default(focusInputRef, inputRef);
    var handleKeyDown = wrapEvent_1.default(onKeyDownProp, onKeyDown);
    var handleChange = wrapEvent_1.default(onChangeProp, onChange);
    var handleFocus = wrapEvent_1.default(onFocusProp, onFocus);
    var handleBlur = wrapEvent_1.default(onBlurProp, onBlur);
    if (typeof children === 'function') {
        var render = children;
        return react_1.default.createElement(react_1.default.Fragment, null, render.apply(void 0, __spread(inputProps)));
    }
    var Tag = tag;
    var combinedProps = __assign(__assign({ value: value, onChange: handleChange, onFocus: handleFocus, onBlur: handleBlur, onKeyDown: handleKeyDown, ref: ref }, restInputProps), props);
    return react_1.default.createElement(Tag, __assign({}, combinedProps));
};
if (process.env.NODE_ENV !== 'production') {
    AcdcInput.propTypes = {
        children: renderPropType_1.default([]),
    };
}
exports.default = react_1.memo(AcdcInput);
